import { t } from "i18next";
import { values } from "ramda";

export const NEETO_WIDGET_USER_IDENTITY_KEY = "NeetoWidgetUserIdentity";
export const SESSION_CONTEXT_KEY = "NeetoReplayWidgetSessionContext";

export const INSTALLATION_HELP_EMAIL = "support@neeto.com";

export const SAMPLE_CONTEXT_CODE_STRING = `window.${SESSION_CONTEXT_KEY} = {
  key1: "value",
  key2: ["array", "of", "values"],
  /* More key-value pairs */
}`;

export const WIDGET_TYPES = {
  engage: "engage",
  chat: "chat",
  replay: "replay",
};

export const WIDGET_HELP_LINKS = {
  engage: "https://help.neetoengage.com/articles/installation",
  chat: "https://help.neetochat.com/articles/installation-using-javascript-snippet",
  replay: "https://help.neetoreplay.com/articles/install-widget",
};

export const WIDGET_DESCRIPTIONS = {
  engage: t(
    "neetoMolecules.widget.email.body.values.embedCode.description.engage"
  ),
  chat: t("neetoMolecules.widget.email.body.values.embedCode.description.chat"),
  replay: t(
    "neetoMolecules.widget.email.body.values.embedCode.description.replay"
  ),
};

export const WIDGET_TYPES_VALUES = values(WIDGET_TYPES);

export const QUERY_KEYS = {
  apiKey: "neetoWidgetApiKey",
  configuration: "neetoWidgetConfiguration",
};

export const DEFAULT_QUERY_STALE_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

export const EMAIL_TYPES = {
  embedCode: "embedCode",
  userIdentity: "userIdentity",
  sessionContext: "sessionContext",
  null: "",
};

export const RAILS_ENV = {
  production: "production",
  staging: "staging",
  development: "development",
};

export const NEETO_WIDGET_SCRIPT_URL = {
  staging: "https://d3nshle8hzelnq.cloudfront.net/neeto-widget-staging.js",
  production: "https://d13nryxs46eypn.cloudfront.net/neeto-widget.js",
};

export const AVAILABLE_FRAMEWORK_OPTIONS = Object.freeze({
  rails: "rails",
  django: "django",
  php: "php",
});

export const FRAMEWORK_SELECT_OPTIONS = [
  { label: "Ruby(Rails)", value: AVAILABLE_FRAMEWORK_OPTIONS.rails },
  { label: "Python(Django)", value: AVAILABLE_FRAMEWORK_OPTIONS.django },
  { label: "PHP", value: AVAILABLE_FRAMEWORK_OPTIONS.php },
];

export const SAMPLE_USER_IDENTITY_CODE_STRING = {
  [AVAILABLE_FRAMEWORK_OPTIONS.rails]: `window.${NEETO_WIDGET_USER_IDENTITY_KEY} = {
  user_identifier: "<%= current_user.id %>", // User identifier"
  name: "<%= current_user.name %>", // Full name
  email: "<%= current_user.email %>", // Email address
  started_at: "<%= current_user.created_at.to_i %>" // Signup date as a Unix timestamp ,
}`,
  [AVAILABLE_FRAMEWORK_OPTIONS.django]: `window.${NEETO_WIDGET_USER_IDENTITY_KEY} = {
  user_identifier: "{{ request.user.id|escapejs }}", // User identifier
  name: "{{ request.user.name|escapejs }}", // Full name
  email: "{{ request.user.email|escapejs }}", // Email address
  started_at: "{{ request.user.created_at|date:'U' }}" // Signup date as a Unix timestamp"
}`,
  [AVAILABLE_FRAMEWORK_OPTIONS.php]: `window.${NEETO_WIDGET_USER_IDENTITY_KEY} = {
  user_identifier: <?php echo json_encode($current_user->id) ?>, // User identifier
  name: <?php echo json_encode($current_user->name) ?>, // Full name
  email: <?php echo json_encode($current_user->email) ?>, // Email address
  started_at: <?php echo strtotime($current_user->created_at) ?> // Signup date as a Unix timestamp" ,
}`,
};
export const WIDGET_CONFIG_URL = "/api/widget/v1/neeto_widget_tokens";
export const EMBED_CODE_EMAIL_URL = "/api/widget/v1/email_snippets";
export const CHAT_WIDGET_KB_BASE_URL = "https://help.neetochat.com";
export const ENGAGE_WIDGET_KB_BASE_URL = "https://help.neetoengage.com";
export const REPLAY_WIDGET_KB_BASE_URL = "https://help.neetoreplay.com";
export const NEETO_REPLAY_CONFIGURE_URL = `${REPLAY_WIDGET_KB_BASE_URL}/articles/configure-widget`;
export const NEETO_CHAT_USER_IDENTITY_URL = `${CHAT_WIDGET_KB_BASE_URL}/articles/info-about-logged-in-users`;
export const WIDGET_KB_HELP_URL = {
  engage: `${ENGAGE_WIDGET_KB_BASE_URL}/categories/widget-installation-usage`,
  chat: `${CHAT_WIDGET_KB_BASE_URL}/folders/installation`,
  replay: `${REPLAY_WIDGET_KB_BASE_URL}/categories/widget-installation-usage`,
};
export const USE_NEETO_WIDGET_NPM_PAGE_URL =
  "https://www.npmjs.com/package/@bigbinary/react-use-neeto-widget";
